import $ from "jquery";
import Ajax from "base/Ajax";
import Page from "./webPage/Page";

export default class Distributors {

    constructor($element) {
        this.$element = $element;

        this.$filters = this.$element.find('.js-filters-form');
        this.$distributorsWrap = this.$element.find('.js-distributor-wrap');

        this.request = null;

        this.filters = {};

        this.bindEvents();

        this.getLatestFilters();
    }

    bindEvents() {
        let me = this;

        this.$element.on('change', '.js-filter-value', () => {
            let selected_country_name = $('.js-filter-value').find(':selected').text();
            $(".js-country-name").html(selected_country_name);
            this.getLatestFilters();
            this.getDistributors(true);
        });

        window.onpopstate = function (event) {
            let filters = {};

            let pageRegexp = new RegExp('^.*/page/([0-9]+)/?');
            let pagePattern = pageRegexp.exec(window.location.pathname);

            if (pagePattern !== null && 'undefined' !== typeof pagePattern[0]) {
                filters.page = pagePattern[1];
            }

            let queryString = Page.get_query();

            me.filters = $.extend(true, {}, filters, queryString);

            console.log(me.filters);
            console.log(queryString);

            me.updateFilters();
            me.getDistributors(false);
        }
    }

    clearFilters() {
        this.$filters.find('select').val('');
    }

    updateFilters() {
        this.clearFilters();

        Object.keys(this.filters).forEach((key) => {
            if('undefined' !== typeof key) {
                let value = this.filters[key];
                this.$filters.find('select[name="' + key + '"]').val(value);
            }
        });
    }

    getLatestFilters() {
        this.filters = this.$filters.serializeJSON();
    }

    getDistributors(pushState) {
        this.$distributorsWrap.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wp/v2', 'distributor', this.filters);
        this.updateFilters();

        this.request.then((data) => {
            this.request = null;
            this.$distributorsWrap.removeClass('loading');

            let headers = {};
            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }

            this.updateDistributors(data, headers);
        }).catch((e) => {
            this.request = null;
            this.$distributorsWrap.removeClass('loading');
            console.log(e);
        });

        if (pushState) {
            history.pushState({}, '', this.fullPageUrl());
        }
    }

    pageUrl() {
        return window.location.pathname.replace(/page\/[0-9]\//g, '');
    }

    fullPageUrl() {
        let base = this.pageUrl();

        let page = '';

        if ('undefined' !== typeof this.filters.page && this.filters.page > 1) {
            page = 'page/' + this.filters.page + '/';
        }

        let queryString = this.pageQueryString();

        return base + page + queryString;
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        link += this.pageQueryString(link);

        return link;
    }

    pageQueryString() {
        let queryString = '';
        let filters = Object.assign({}, this.filters);

        delete filters.page;

        if (Object.keys(filters).length > 0) {
            queryString += "?" + $.param(filters).replace(/%5B%5D/g, "[]");
        }

        return queryString;
    }

    updateDistributors(data, headers) {
        if ('undefined' !== typeof data && data.length > 0) {
            this.$distributorsWrap.html('');
            data.forEach((distributor) => {
                this.$distributorsWrap.append(this.buildDistributor(distributor));
            });
        } else {
            this.showNoDistributorMessage();
        }
    }

    buildDistributor(distributor) {
        return (
            eotwJSXFactory('article', {className: "distributor"}, [
                eotwJSXFactory('div', {className: "distributor__logo", unsafeHtml: distributor["distributor_logo"]}),
                eotwJSXFactory('div', {className: "distributor__content"}, [
                    eotwJSXFactory('div', {className: "distributor__content-left"}, [
                        eotwJSXFactory('p', {className: "red-text"}, [distributor["distributor_name"]]),
                        eotwJSXFactory('div', {className: "distributor__address", unsafeHtml: distributor["distributor_address"]})
                    ]),
                    eotwJSXFactory('div', {className: "distributor__content-right"}, [
                        distributor["distributor_telephone_number"] ? (
                            eotwJSXFactory('p', null, [eotwJSXFactory('a', {href: "tel:" + distributor["distributor_telephone_number"]}, [eotwJSXFactory('strong', null, [distributor["distributor_telephone_number"]])])])
                        ) : (""),
                        distributor["distributor_email_address"] ? (
                            eotwJSXFactory('p', null, [eotwJSXFactory('a', {href: "mailto:" + distributor["distributor_email_address"]}, [distributor["distributor_email_address"]])])
                        ) : (""),
                        distributor["distributor_website_link"] ? (
                            eotwJSXFactory('p', null, [eotwJSXFactory('a', {href: distributor["distributor_website_link"]["url"], rel: "noreferrer", target: "_blank"}, [distributor["distributor_website_link"]["title"]])])
                        ) : (""),
                        distributor["distributor_information"] ? (
                            eotwJSXFactory('div', {className: "distributor__info"}, [
                                eotwJSXFactory('p', {unsafeHtml: distributor["distributor_information"]})
                            ])
                        ) : ("")
                    ])
                ])
            ])
        )
    }

    showNoDistributorMessage() {
        this.$distributorsWrap.html(
            eotwJSXFactory('div', {className: "empty-message"}, [
                eotwJSXFactory('p', null, ["No distributors found"])
            ])
        );
    }
}
